module.exports = __webpack_public_path__ + "img/ryno_white_new.e59f251f.svg";